const middleware = {}

middleware['runConfig'] = require('../../../middleware/runConfig.js')
middleware['runConfig'] = middleware['runConfig'].default || middleware['runConfig']

export default middleware
